<template>
  <div>
    <v-container fluid>
      <v-row dense class="pb-0">
        <v-col cols="2">
          <date-picker label="As of" v-model="asof" date-only hide-details @change="refresh"/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('QBO inventory accounts', report())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 184px)">
      <span v-html="report()"/>
    </v-card>

  </div>
</template>

<script>
import {format} from 'date-fns'
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsInventoryQBOInventoryAccounts',
  mixins: [printHtml],
  data() {
    return {
      asof: format(new Date(), 'yyyy-MM-dd'),
      accounts: []
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  async created() {
    this.$emit('name', 'QBO inventory accounts')
    this.refresh();
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query ReportsInventoryQBOInventoryAccounts($asof:DateTime!) {
                                                qboInventoryAccounts(asof:$asof) {
                                                  name, objects {type,name,value}
                                                }
                                              }`,
                                          {asof:`${this.asof} 23:59:59`});
      if (!results.error)
        this.accounts = results.data.qboInventoryAccounts;
    },

    report() {
    const lines = [
                  `<style>
                    @page {size:portrait}
                    .qbo-accounts {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px}
                    .qbo-accounts th {height:36px;padding:0 16px;vertical-align:middle}
                    .qbo-accounts .spacer {height:18px}
                    .qbo-accounts td {height:36px;padding:0 16px;vertical-align:middle}
                    .qbo-accounts .title {font-size:18px;text-transform:uppercase}
                    .qbo-accounts .sup-title {font-weight:normal;font-size:22px}
                    .qbo-accounts .sub-title {font-weight:normal;margin-bottom:20px;font-size:14px}
                    .qbo-accounts .header th {border-bottom:1px solid #000;margin-bottom:20px}
                    .qbo-accounts .text-left {text-align:left}
                    .qbo-accounts .text-right {text-align:right}
                  </style>
                  <table class="qbo-accounts">
                  <thead>
                    <tr>
                      <th colspan="8">
                        <div class="sup-title">${this.company.name}</div>
                      </th>
                    </tr>
                    <tr>
                      <th colspan="8">
                        <div class="title">QBO inventory accounts</div>
                      </th>
                    </tr>
                    <tr>
                      <th colspan="8">
                        <div class="sub-title">As of ${this.$formatDate(this.asof)}</div>
                      </th>
                    </tr>
                    <tr class="header">
                      <th width="30%" class="text-left">QBO account</th>
                      <th width="25%" class="text-left">Purtrak type</th>
                      <th width="30%" class="text-left">Purtrak name</th>
                      <th width="15%" class="text-right">Value</th>
                    </tr>
                  </thead>
                  <tbody>`
    ];
    for (const account of this.accounts) {
      let firstLine = true;
      lines.push(`<tr>`);
      lines.push(`<td>${account.name}</td>`);
      let total = 0;
      for (const obj of account.objects) {
        if (!firstLine) {
          lines.push(`<tr>`);
          lines.push(`<td/>`);
        }
        lines.push(`<td>${obj.type}</td>`);
        lines.push(`<td>${obj.name}</td>`);
        lines.push(`<td class="text-right">$${this.$number(obj.value,2)}</td>`);
        lines.push(`</tr>`);
        firstLine = false;
        total += obj.value;
      }
      lines.push(`<tr><td colspan="3" class="text-right"><b>Total:</b></td><td class="text-right"><b>$${this.$number(total,2)}</b></td></tr>`)
    }
    lines.push(`</tbody>`);
    lines.push(`</table>`);
    return lines.join('');
    },
    exportCSV() {
      const lines = [ `"${this.company.name}",,,`,
                      `"QBO inventory accounts",,,`,
                      `"As of ${this.$formatDate(this.asof)}",,,`,
                      `"QBO account","Purtrak type","Purtrak name","Value"`
                    ];

      for (const account of this.accounts) {
        for (const obj of account.objects)
          lines.push(`"${account.name}","${obj.type}","${obj.name}","${obj.value}"`);
      }

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'QBO inventory accounts.csv');
    }
  }
}
</script>